// extracted by mini-css-extract-plugin
export default {"EmployeesPage":"EmployeesPage_EmployeesPage__HZSBO"};